(function () {
  function initOneHeaderDrawerTabs(hd) {
    if (!hd || hd.getAttribute('data-drawer-nav') !== 'top_tabs') return;

    var details = hd.querySelector('details.menu-drawer-container--header-root');
    var summary = details && details.querySelector('summary');
    var tabs = hd.querySelectorAll('.header__drawer-tab[role="tab"]');
    var panels = hd.querySelectorAll('.menu-drawer__tab-panel');
    var closeBtn = hd.querySelector('.menu-drawer__close-main-drawer');

    if (!details || !summary) return;

    function openDrawer() {
      if (!details.hasAttribute('open')) {
        summary.click();
      }
    }

    function activatePanel(index) {
      tabs.forEach(function (t) {
        var idx = parseInt(t.getAttribute('data-tab-index'), 10);
        var selected = idx === index;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
      });
      panels.forEach(function (p) {
        var pi = parseInt(p.getAttribute('data-panel-index'), 10);
        p.hidden = pi !== index;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(tab.getAttribute('data-tab-index'), 10);
        var alreadySelected = tab.getAttribute('aria-selected') === 'true';
        if (details.hasAttribute('open') && alreadySelected) {
          summary.click();
          return;
        }
        openDrawer();
        activatePanel(idx);
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (details.hasAttribute('open')) {
          summary.click();
        }
      });
    }

    details.addEventListener('toggle', function () {
      if (!details.open) {
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });
      }
    });
  }

  function initHeaderDrawerTabs() {
    document.querySelectorAll('header-drawer[data-drawer-nav="top_tabs"]').forEach(initOneHeaderDrawerTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderDrawerTabs);
  } else {
    initHeaderDrawerTabs();
  }
})();
